import React from 'react';
import {curry} from 'ramda';
import classnames from 'classnames';
import {Link} from 'react-router-dom';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';

export interface MapLinkToListItemParams {
    route: string;
    icon: JSX.Element;
    title: string;
}

export const getIsActiveLink = curry((currentRouter: string, router: string) => {
    return currentRouter === router;
});

export const mapLinkToListItem = curry((isActiveLink, {route, icon, title}: MapLinkToListItemParams) => {
    return (
        <ListItem
            key={title}
            className={classnames({
                active: isActiveLink(route),
            })}
            button
            component={Link}
            to={route}
        >
            <ListItemIcon>
                {icon}
            </ListItemIcon>
            <ListItemText primary={title} />
        </ListItem>
    );
});
